//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    users: [],
    searchUserRequest: {},
  },
  mutations: {
    updateUsers(state, users) {
      state.users = users;
    },
    updateSearchUserRequest(state, searchUserRequest) {
      state.searchUserRequest = searchUserRequest;
    },
  },
  actions: {
    async loadUsers({ commit, state }, searchUserRequest) {
      const fallBacksSarchUserRequest = searchUserRequest || state.searchUserRequest;
      const reqSearchUserRequest = JSON.parse(JSON.stringify(fallBacksSarchUserRequest));
      if (reqSearchUserRequest.fromUsername && !reqSearchUserRequest.toUsername) {
        reqSearchUserRequest.toUsername = reqSearchUserRequest.fromUsername;
      }
      //const users = await api.post('/api/w/users', reqSearchUserRequest);
      const users = await newAPIPost('/api/w/users', reqSearchUserRequest);
      commit('updateSearchUserRequest', fallBacksSarchUserRequest);
      console.log("users: " + JSON.stringify(users));
      return commit('updateUsers', users);
    },
    getUsersByCategory(store, { category, dontFilterDisabled }) {
      //return api.post('/api/w/users', { category })
      return newAPIPost('/api/w/users', { category })
        .then(res => _.chain(res)
          .filter(it => dontFilterDisabled === true || it.disabled !== true)
          .map(it => ({
            id: it.username,
            name: it.name,
            ccicTeams: it.ccicTeams,
            group: it.driverGroup,
          }))
          .sortBy(it => it.id)
          .value());
    },

    getDriversBy(store, { defaultSalesOffice }) {
      //return api.post('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice })
      return newAPIPost('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice })
        .then(res => _.chain(res)
          .map(it => ({
            id: it.shortId,
            name: it.driverMobile,
            plate: it.defaultPlateNum,
            trail: it.trailernum,
          })).filter(it => it.source != "OUTBOUND")
          .sortBy(it => it.id)
          .value());
    },

    getDriversByFSI(store, { defaultSalesOffice, driverOffice }) {
      //return api.post('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice: defaultSalesOffice, driverOffice: 'FSI'  })
      return newAPIPost('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice: defaultSalesOffice, driverOffice: 'FSI'  })
        .then(res => _.chain(res)
          .map(it => ({
            id: it.shortId,
            name: it.driverMobile,
            plate: it.defaultPlateNum,
            trail: it.trailernum,
          })).filter(it => it.driverOffice == driverOffice)
          .sortBy(it => it.id)
          .value());
    },

    getDriversBySource(store, { defaultSalesOffice, driverOffice, source}) {
      console.log("defaultSalesOffice: " + defaultSalesOffice)
      console.log("source: " + source)
      //return api.post('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice: defaultSalesOffice, driverOffice: driverOffice })
      return newAPIPost('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice: defaultSalesOffice, driverOffice: driverOffice })
        .then(res => _.chain(res)
          .map(it => ({
            id: it.shortId,
            name: it.driverMobile,
            plate: it.defaultPlateNum,
            trail: it.trailernum,
            source: it.source,
          })).filter(it => it.source === source)
          .sortBy(it => it.id)
          .value());
    },

    createUser({ dispatch }, createUserRequest) {
      //return api.post('/api/w/users/create', createUserRequest);
      //return api.post('/api/w/users/createWithMFA', createUserRequest);
      return newAPIPost('/api/w/users/createWithMFA', createUserRequest);
    },
    updateUser({ dispatch }, updateUserRequest) {
      //return api.post('/api/w/users/update', updateUserRequest);
      return newAPIPost('/api/w/users/update', updateUserRequest);
    },
  },
  getters: {
    getUsers: state => state.users,
  },
};
